import React, { useEffect, useState } from 'react';
import './Vehicles.css';
import { useI18n } from '../../i18n/I18n';
import teslaImg from '../../images/pct6.jpg';
import placeholderImg from '../../images/pct.jpeg';
import egeaImg from '../../images/pct7.jpg';
import ex40Img from '../../images/pct8.jpeg';
import tiguanImg from '../../images/pct10.jpeg';
import jaecooImg from '../../images/pct12.jpeg';
import tiggoImg from '../../images/pct11.jpeg';

type Car = {
  id: string;
  name: string;
  class: 'Ekonomi' | 'Orta' | 'SUV' | 'Premium';
  transmission: 'Manuel' | 'Otomatik';
  fuel: 'Benzin' | 'Dizel' | 'Hibrit' | 'Elektrikli';
  pricePerDay: number; // başlayan fiyat
  image?: string; // resolved url
};

const CARS: Car[] = [
  { id: 'modely', name: 'Tesla Model Y', class: 'SUV', transmission: 'Otomatik', fuel: 'Elektrikli', pricePerDay: 3500, image: teslaImg },
  { id: 'egea', name: 'Toyota Corolla Cross', class: 'SUV', transmission: 'Otomatik', fuel: 'Hibrit', pricePerDay: 900, image: egeaImg },
  { id: 'ex40', name: 'Volvo EX40', class: 'SUV', transmission: 'Otomatik', fuel: 'Elektrikli', pricePerDay: 3200, image: ex40Img },
  { id: 'focus', name: 'Volkswagen Tiguan', class: 'SUV', transmission: 'Otomatik', fuel: 'Benzin', pricePerDay: 1250, image: tiguanImg },
  { id: 'tiggo8', name: 'Chery Tiggo 8', class: 'SUV', transmission: 'Otomatik', fuel: 'Benzin', pricePerDay: 1450, image: tiggoImg },
  { id: 'jaecoo7', name: 'Jaecoo 7', class: 'SUV', transmission: 'Otomatik', fuel: 'Benzin', pricePerDay: 1800, image: jaecooImg },

];

const Vehicles: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const { t } = useI18n();

  useEffect(() => {
    const id = window.setTimeout(() => setLoading(false), 600);
    return () => window.clearTimeout(id);
  }, []);

  const list = CARS;

  const onQuote = (carId: string) => {
    try { (window as any).dataLayer = (window as any).dataLayer || []; (window as any).dataLayer.push({ event: 'quote_click', location: 'vehicles', car_id: carId }); } catch {}
  };

  // filtreler kaldırıldı

  const renderImage = (c: Car, idx: number) => {
    if (!c.image) return null;
    const lower = c.image.toLowerCase();
    if (lower.endsWith('.webp')) {
      return (
        <picture>
          <source type="image/avif" srcSet={c.image.replace('.webp', '.avif')} />
          <source type="image/webp" srcSet={c.image} />
          <img
            className="car-img"
            src={c.image}
            alt={c.name}
            loading="lazy"
            decoding="async"
            fetchPriority={idx < 2 ? 'high' : 'auto'}
            sizes="(max-width: 600px) 100vw, (max-width: 992px) 50vw, 33vw"
          />
        </picture>
      );
    }
    // jpg/png fallback
    return (
      <img
        className="car-img"
        src={c.image}
        alt={c.name}
        loading="lazy"
        decoding="async"
        fetchPriority={idx < 2 ? 'high' : 'auto'}
        sizes="(max-width: 600px) 100vw, (max-width: 992px) 50vw, 33vw"
      />
    );
  };

  return (
    <section className="vehicles" id="vehicles">
      <div className="vehicles-container">
        <h2>{t('vehicles.title')}</h2>

        {/* Kategori sekmeleri kaldırıldı */}

        {/* Filtreler ve sonuç özeti kaldırıldı */}

        <div className="grid" aria-busy={loading}>
          {loading ? (
            Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="car-card skeleton-card" aria-hidden="true">
                <div className="skeleton-img" />
                <div className="skeleton-line w-60" />
                <div className="skeleton-badges">
                  <span className="skeleton-pill" />
                  <span className="skeleton-pill" />
                </div>
                <div className="skeleton-line w-40" />
                <div className="skeleton-btn" />
              </div>
            ))
          ) : (
            list.map((c, idx) => (
              <div key={c.id} className="car-card">
                <div className="price-badge">
                  {t('vehicles.monthlyPrice')}
                  <span className="info" tabIndex={0} aria-label={t('vehicles.priceOnRequest')}>i
                    <span className="tooltip">{t('vehicles.priceOnRequest')}</span>
                  </span>
                </div>
                <div className="car-media">{renderImage(c, idx)}</div>
                <div className="car-name">{c.name}</div>
                <div className="specs">
                  <span className="badge class">{c.class}</span>
                  <span className={`badge fuel ${c.fuel.toLowerCase()}`}>{c.fuel}</span>
                  <span className="badge trans">{c.transmission}</span>
                </div>
                <div className="card-actions">
                  <a className="btn btn-sm" href="/teklif" onClick={() => onQuote(c.id)}>{t('vehicles.quote')}</a>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default Vehicles; 